import React, { useEffect, useState } from 'react';
import { Table, Alert, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaDownload } from 'react-icons/fa';
import { postDataLogin } from '../ApiServices/ApiService';
import { postData } from '../ApiServices/ApiService';

const LatestInterviews = (props) => {
  const [data, setData] = useState([]);
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [loadingWithScore, setLoadingWithScore] = useState(false);
  const [clientCategory,setClientCategory]=useState(false)


  useEffect(() => {
    setData(props.data);
  }, [props.data]);
  useEffect(() => {
    if(props?.category ==='HOSPITALITY'){
      setClientCategory(true);
    }else{
      setClientCategory(false);
    }
    
  }, [props.category]);


  const [selectedOption, setSelectedOption] = useState(10);

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    setCurrentPage(1)
  }
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = selectedOption; // Set the number of items per page

  const totalPages = Math.ceil(data.length / itemsPerPage);
  const pageRange = 2; // Number of page buttons to show on each side of the current page

  const getPageRange = () => {
    const start = Math.max(1, currentPage - pageRange);
    const end = Math.min(totalPages, currentPage + pageRange);

    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'Selected':
        return 'green';
      case 'Pending':
        return 'blue';
      case 'Rejected':
        return 'red';
      default:
        return 'black'; // default color, you can change it as needed
    }
  };

  const [sortOrder, setSortOrder] = useState('asc');
  const [sortOrderById, setSortOrderById] = useState('asc');
  const [sortOrderClient, setSortOrderClient] = useState('asc');
  const [sortByExamCoding, setSortByExamCoding] = useState('asc');
  const [sortOrderScoreCode, setSortOrderScoreCode] = useState('asc')

  const toggleSortOrder = (sortedValue) => {
    if (sortedValue === 'jobname') {
      const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
      setSortOrder(newSortOrder);

      // Sort the data based on the current sort order
      const sorted = [...data].sort((a, b) => {
        const nameA = a?.candidate_name?.toUpperCase();
        const nameB = b?.candidate_name?.toUpperCase();

        if (newSortOrder === 'asc') {
          return nameA.localeCompare(nameB);
        } else {
          return nameB.localeCompare(nameA);
        }
      });

      // setSortedData(sorted);
      setData(sorted);
    } else if (sortedValue === 'score') {
      const newSortOrder = sortOrderClient === 'asc' ? 'desc' : 'asc';
      setSortOrderClient(newSortOrder);

      // Sort the data based on the current sort order
      const sortedClient = [...data].sort((a, b) => {
        const scoreA = parseInt(a?.overall_avg_score, 10) || 0;
        const scoreB = parseInt(b?.overall_avg_score, 10) || 0;
      
        if (newSortOrder === 'asc') {
          return scoreA - scoreB;
        } else {
          return scoreB - scoreA;
        }
      });
      
      setData(sortedClient);
      
    } else if (sortedValue === 'scorecode') {
      const newSortOrder = sortOrderScoreCode === 'asc' ? 'desc' : 'asc';
      setSortOrderScoreCode(newSortOrder);

      // Sort the data based on the current sort order
      const sortedClient = [...data].sort((a, b) => {
        const scoreA = parseInt(a?.overall_avg_score, 10) || 0;
        const scoreB = parseInt(b?.overall_avg_score, 10) || 0;
      
        if (newSortOrder === 'asc') {
          return scoreA - scoreB;
        } else {
          return scoreB - scoreA;
        }
      });
      
      setData(sortedClient);
      
    }
    else if (sortedValue === 'examcode') {
      const newSortOrder = sortByExamCoding === 'asc' ? 'desc' : 'asc';
      setSortByExamCoding(newSortOrder);

      const sortedData = data.sort((a, b) => {
        const compareResult = sortByExamCoding === 'asc' ? a.exam_status.localeCompare(b.exam_status) : b.exam_status.localeCompare(a.exam_status);
        return compareResult;
      });

      setData(sortedData);
    }
    else {
      const newSortOrder = sortOrderById === 'asc' ? 'desc' : 'asc';
      setSortOrderById(newSortOrder);

      const sortedData = data.sort((a, b) => {
        const compareResult = sortOrderById === 'asc' ? a.exam_status.localeCompare(b.exam_status) : b.exam_status.localeCompare(a.exam_status);
        return compareResult;
      });

      setData(sortedData);
    }



  };

  const downloadWithScore = async (event) => {

    const payload = {
      "test_id": event,
      "with_score": 1
    }

    // setLoadingWithScore(true)
    setLoadingWithScore(prevLoadingRows => ({ ...prevLoadingRows, [event]: true }));
    try {
      // return
      postData('admin_in/candidate-interview/download-analysis', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setLoadingWithScore(false)
                const fileUrl = respData.dataJ.analysis_report_url

                const link = document.createElement('a');
                link.href = fileUrl;

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                // setLoadingWithScore(false);
                setLoadingWithScore(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
              } else {
                // setLoading(false);
                setLoadingWithScore(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
                console.log('resp else s : ', resp.info);
              }
            } else if (respData.statusCode === 500) {
              setError(respData.info);
              // setLoadingWithScore(false);
              setLoadingWithScore(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
            } else {
              // setLoadingWithScore(false);
              setLoadingWithScore(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
              setError('Network Error');
            }
          } else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            // setLoadingWithScore(false);
            setLoadingWithScore(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            // setLoadingWithScore(false);
            setLoadingWithScore(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
            console.log('resp status else  : ', resp);
          }
        }).catch((error) => {
          // setLoadingWithScore(false);
          setLoadingWithScore(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
          console.log('network error:', error);
        });
      }).catch((error) => {
        // setLoadingWithScore(false);
        setLoadingWithScore(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
        console.log('network error:', error);
      });

    } catch (error) {
      // setLoadingWithScore(false);
      setLoadingWithScore(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
      console.error('Error sending data:', error);
    }
  }
  const downloadWithoutScore = async (event) => {

    const payload = {
      "test_id": event,
      "with_score": 0
    }

    setLoading(true)
    setLoading(prevLoadingRows => ({ ...prevLoadingRows, [event]: true }));
    try {
      // return
      postData('admin_in/candidate-interview/download-analysis', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setLoading(false)
                const fileUrl = respData.dataJ.analysis_report_url

                const link = document.createElement('a');
                link.href = fileUrl;

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                setLoading(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
              } else {
                // setLoading(false);
                setLoading(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));

              }
            } else if (respData.statusCode === 500) {
              setError(respData.info);
              // setLoading(false);
              setLoading(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
            } else {
              // setLoading(false);
              setLoading(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
              setError('Network Error');
            }
          } else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            // setLoading(false);
            setLoading(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            // setLoading(false);
            setLoading(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
            console.log('resp status else  : ', resp);
          }
        }).catch((error) => {
          // setLoading(false);
          setLoading(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
          console.log('network error:', error);
        });
      }).catch((error) => {
        // setLoading(false);
        setLoading(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
        console.log('network error:', error);
      });

    } catch (error) {
      // setLoading(false);
      setLoading(prevLoadingRows => ({ ...prevLoadingRows, [event]: false }));
      console.error('Error sending data:', error);
    }
  }



  const YourComponent = ({ job, index }) => {
    return (
      <tr key={index}>
        <td style={{ paddingLeft: '15px', textAlign: 'end' }} >{index + 1}</td>
        <td className=''> <Link to={`/candidate-info?id=${job?.test_id}`} style={{ textDecoration: 'none', color: 'blue' }}>{job?.candidate_name} </Link></td>
        <td className=''>{job?.candidate_email}</td>
          {/* <td>{job?.phone_number}</td>
          <td>{job?.create_at}</td>
          <td>{job?.exam_start_at}</td>
          <td>{job?.exam_end_at}</td> */}
           {(!clientCategory &&(
        <td className='text-center'>
          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px' }}>
            <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d' }}>
            {job?.exam_type === "THEORY" ? <>{job?.overall_avg_score}</>:<>-</>}
             
            </div>
            <div className='text-center col-6 col-md-6' >
            {job?.exam_type === "CODING" ? <>{job?.overall_avg_score}</>:<>-</>}
              
            </div>
          </div>
        </td>
           ))}
           {clientCategory &&(
            <td className='text-center'>{job?.overall_avg_score}</td>
           )}
        {/* <td >{job?.test_status}</td> */}
        {/* <td style={{textAlign:'end'}}>{job?.test_time}</td> */}
        {(!clientCategory &&(
        <td className='text-center'>

          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px' }}>
            <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d' }}>
            {job?.exam_type === "THEORY" ? <>{job?.exam_status}</>:<>-</>}
            </div>
            <div className='text-center col-6 col-md-6' >
            {job?.exam_type === "CODING" ? <>{job?.exam_status}</>:<>-</>}
            </div>
          </div>
        </td>
        ))}
        {clientCategory &&(
          <td className='text-center'>{job?.exam_status}</td>
        )}

        <td className='text-center' >
          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px' }}>
            <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d' }}>
              {job?.exam_type === "THEORY" ? <>
              {(!job?.report_path) ? (
                <FaDownload style={{ opacity: '0.1' }} />
              ) : (<>
                <FaDownload
                  type="submit"
                  onClick={() => downloadWithScore(job.test_id)}
                />
                {loadingWithScore[job.test_id] && (
                  <div className="" style={{ height: '20px', top: 0, left: 0 }}>
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
              </>
              )}
              </>: <>
              <FaDownload style={{ opacity: '0.1' }} />
              </>}

            </div>
            <div className='text-center col-6 col-md-6' >
              {job?.exam_type === "THEORY" ? <>
              {(!job?.report_path) ? (
                <FaDownload style={{ opacity: '0.1' }} />
              ) : (<>
                <FaDownload
                  type="submit"
                  onClick={() => downloadWithoutScore(job.test_id)}
                />
                {loading[job.test_id] && (
                  <div className="" style={{ height: '20px', top: 0, left: 0 }}>
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}</>
              )}
              </>:<>
              <FaDownload style={{ opacity: '0.1' }} />
              </>}

            </div>
          </div>
        </td>
        {!clientCategory &&(
        <td className='text-center' >
          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px' }}>
            <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d' }}>
              {job?.exam_type === "CODING" ? <>
              {(!job?.report_path) ? (
                <FaDownload style={{ opacity: '0.1' }} />
              ) : (<>
                <FaDownload
                  type="submit"
                  onClick={() => downloadWithScore(job.test_id)}
                />
                {loadingWithScore[job.test_id] && (
                  <div className="" style={{ height: '20px', top: 0, left: 0 }}>
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
              </>
              )}
              </>:<>
              <FaDownload style={{ opacity: '0.1' }} />
              </>}
         
            </div>
            <div className='text-center col-6 col-md-6' >
              {job?.exam_type === "CODING" ? <>
              {(!job?.report_path) ? (
                <FaDownload style={{ opacity: '0.1' }} />
              ) : (<>
                <FaDownload
                  type="submit"
                  onClick={() => downloadWithoutScore(job.test_id)}
                />
                {loading[job.test_id] && (
                  <div className="" style={{ height: '20px', top: 0, left: 0 }}>
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}</>
              )}
              </>:
              <><FaDownload style={{ opacity: '0.1' }} />
              </>}
           
            </div>
          </div>
        </td>
          )} 
          <td className=''>{job.jd_resume_match && job.jd_resume_match !== 'NA' ? job.jd_resume_match.Matching : 'NA'}</td>


      </tr>

    );
  };

  return (
    <div className="table-responsive">{currentItems.length > 0 && (<div>
      {success && <Alert variant="danger">{success}</Alert>}
      <div style={{ display: 'flex', justifyContent: 'end', marginBottom: '10px', marginRight: '20px', marginLeft: '0px' }}>
        <div className='' style={{ marginRight: '10px', paddingRight: '15px' }}>
          <label htmlFor='dropdown' style={{ color: '#275290', fontSize: '14px', padding: '5px' }}> Interviews Per Page</label>
          <select id="dropdown" className='page-no-dropdown' value={selectedOption} onChange={handleSelectChange} style={{ borderRadius: '5px' }}>
            <option value="10" >10</option>
            <option value="20" >20</option>
            <option value="40" >40</option>
            <option value="50" >50</option>
            <option value="60" >60</option>
            <option value="70" >70</option>
            <option value="80" >80</option>
            <option value="100" >100</option>
          </select>

        </div>
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <button
            onClick={() => paginate(currentPage - 1)}
            className='page-nation-btn'
            disabled={currentPage === 1}
          >
            Prev
          </button>

          {getPageRange().map((page) => (
            <button
              key={page}
              onClick={() => paginate(page)}
              className='page-nation-btn'
              style={{
                backgroundColor: page === currentPage ? '#007BFF' : 'white',
                color: page === currentPage ? 'white' : 'black',
              }}
            >
              {page}
            </button>
          ))}

          <button
            onClick={() => paginate(currentPage + 1)}
            className='page-nation-btn'
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
      <Table striped bordered hover>
        <thead>
          {/* <tr style={{ backgroundColor: '#EDF2FB' }}>
          <th></th>
            <th></th>
            <th ></th>
            <th></th>
            <th colSpan="2" className='text-center'>Download</th>
          </tr> */}
          <tr>

            <th style={{ color: '#0073b1', textAlign: 'end' }}>##</th>
            <th className='' style={{ color: '#0073b1', cursor: 'pointer', }} onClick={() => toggleSortOrder('jobname')}><span style={{ display: 'flex' }}> <span style={{ flex: 'auto' }}>Candidate Name</span> <span>{sortOrder === 'asc' ? ' ▲' : ' ▼'} </span></span></th>
            <th className='' style={{ color: '#0073b1' }}>Candidate Email</th>
                {/* <th>Phone Number</th>
                <th>Created At</th>
                <th>Started At</th>
                <th>Ended At</th> */}
                {(!clientCategory &&(
            <th className='text-center' style={{ color: '#0073b1', cursor: 'pointer', }} >Comprehensive Score <br />
              <div style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid #8080803d', margin: '0px' }}>
                <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', color: '#0073b1' }} onClick={() => toggleSortOrder('score')}>Skills 
                 <span>{sortOrderClient === 'asc' ? ' ▲' : ' ▼'}</span>
                 </div>
                <div className="col-6 col-md-6" style={{ color: '#0073b1' }} onClick={() => toggleSortOrder('scorecode')}>Coding 
                 <span>{sortOrderScoreCode === 'asc' ? ' ▲' : ' ▼'}</span>
                 </div>
              </div>
            </th>
            ))}
            {clientCategory && (
              <th className='text-center' style={{ color: '#0073b1', cursor: 'pointer', }} >Comprehensive Score</th>
            )}
            {/* <th>Test Status</th> */}
            {/* <th  style={{textAlign:'end'}}>Test Time</th> */}
            {(!clientCategory &&(
            <th className='text-center' style={{ color: '#0073b1', cursor: 'pointer', }}>Exam Status<br />
              <div style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid #8080803d', margin: '0px' }}>
                <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', color: '#0073b1' }} onClick={() => toggleSortOrder('examstatus')}>Skills<span>{sortOrderById === 'asc' ? ' ▲' : ' ▼'} </span></div>
                <div className="col-6 col-md-6" style={{ color: '#0073b1' }} onClick={() => toggleSortOrder('examcode')}>Coding<span>{sortByExamCoding === 'asc' ? ' ▲' : ' ▼'} </span></div>
              </div>
            </th>
            ))}
            {(clientCategory &&
            <th className='text-center' style={{ color: '#0073b1', cursor: 'pointer', }}>Exam Status<br />
              
            </th>
            )}
            <th className='text-center' style={{ color: '#0073b1' }}>Download Skills Report<br />
              <div style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid #8080803d', margin: '0px' }}>
                <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', color: '#0073b1' }}>With Score</div>
                <div className="col-6 col-md-6" style={{ color: '#0073b1' }}>Without Score</div>
              </div>
            </th>
            {!clientCategory &&(
            <th className='text-center' style={{ color: '#0073b1' }}>Download Coding Report<br />
              <div style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid #8080803d', margin: '0px' }}>
                <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', color: '#0073b1' }}>With Score</div>
                <div className="col-6 col-md-6" style={{ color: '#0073b1' }}>Without Score</div>
              </div>
            </th>
              )} 

              <th className='text-center' style={{ color: '#0073b1' }}>JD Resume Score</th>
          </tr>
        </thead>
        <tbody>
          {currentItems?.map((job, index) => (
            <YourComponent key={index} job={job} index={index + indexOfFirstItem} />
          ))}
        </tbody>
      </Table></div>)}
    </div>
  );
};

export default LatestInterviews;
